import { useCallback } from 'react';

export const useGeneralTools = () => {
  const getUrlPathname = useCallback(() => {
    return window.location.pathname;
  }, []);

  const setHtmlPageTitle = useCallback((title) => {
    document.title = title ? title : 'Elexity Navigator';
  }, []);

  return {
    getUrlPathname,
    setHtmlPageTitle,
  };
};
